import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { motorsUiRoutes } from '@classifieds-sell/motors-ui';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        children: motorsUiRoutes
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
